import { render, staticRenderFns } from "./StockTransferred.vue?vue&type=template&id=66e9e51e"
import script from "./StockTransferred.vue?vue&type=script&lang=js"
export * from "./StockTransferred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports